import _ from 'lodash';
import ChecksService from "@/modules/checks/ChecksService";
import ChecksSearch from "@/modules/checks/models/ChecksSearch.model";
import EventBus from "@/plugins/event-bus";
import {ON_CHECKS_TABLE_GET_TABLE_DATA} from "@/plugins/event-bus/event-bus-names";
import i18n from "../../../shared/i18n";

const getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    customer: null,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
    },
    searchModel: new ChecksSearch(),
    extraFilters: {},
    expand: 'settlement.customer,created_by,payment',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['check_number'],
      defaultFields: ['check_number', 'pdf', 'action']
    }
  }
};
const getDefaultFields = () => {
  return [
    {
      key: 'starting_check_number',
      label: i18n.t('Starting No.'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'check_number',
      label: i18n.t('Check Number'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'settlement',
      label: i18n.t('Settlement'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'vendor',
      label: i18n.t('Vendor'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'check_date',
      label: i18n.t('Date'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'paid_amount',
      label: i18n.t('Paid'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'check_status',
      label: i18n.t('Check Status'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'single_pdf',
      label: i18n.t('Single Check'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'batch_pdf',
      label: i18n.t('Batch Check'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'created_at',
      label: i18n.t('Created at'),
      sortable: false,
      isVisible: true,
      expand: ''
    },
    {
      key: 'created_by',
      label: i18n.t('Created by'),
      sortable: false,
      isVisible: true,
      expand: ''
    },

  ]
}

export default {
  namespaced: true,
  state: {
    tableSource: 'checks',
    tableData: {
      checks: getDefaultTableData(),
    },
  },
  actions: {
    updateSearchModel({commit, state}, {searchModel, source = null}) {
      commit('updateSearchModel', {
        searchModel: new ChecksSearch({
          ...state.tableData[source || state.tableSource].searchModel,
          ...searchModel
        }),
        source
      });
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];


      if (payload) {
        data = {
          ...payload.pagination,
        };
      } else {
        data = {
          ...currentTableData.pagination,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      //Following logic here is because of double filter, from extra filters and user interaction filters
      let type = null
      if (data.type && data.type.split(',').length === 1) {
        type = data.type;
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      if (type) {
        data.type = type;
      }

      const defaultExpand = currentTableData.expand

      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand}${defaultExpand}`;

      return data;
    },
    async getTableData({commit, dispatch}, payload = null) {

      const params = await dispatch('getTableParams', payload);
      EventBus.$emit(ON_CHECKS_TABLE_GET_TABLE_DATA, {params});
      commit('updateTableLoading', true);

      const response = await ChecksService.getChecks(params);

      commit('updateTableLoading', false);
      if (response.success) {
        const {limit, page} = params

        commit('saveChecksResponse', response.body.results)
        commit('updateTableData', {
          pagination: {limit, page, total: response.body.count},
        });
      }
      return response;
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;

      dispatch('getTableData');
    },
  },
  mutations: {
    updateSearchModel: (state, {searchModel, source}) => {
      state.tableData[source || state.tableSource].searchModel = searchModel
    },
    updateTableLoading: (state, payload) => {
      state.tableData[state.tableSource].loading = payload
    },
    updateTableData: (state, payload) => {
      state.tableData[state.tableSource] = {
        ...state.tableData[state.tableSource],
        ...payload
      }
    },
    saveChecksResponse: (state, payload) => {
      state.tableData[state.tableSource].rows = payload
    },
  }
}